import Tab from 'components/Tab';
import Tabs from 'components/Tabs';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DroneDetailsDrawerTabs: FunctionComponent<Props> = ({
    activeIndex,
    className = '',
    onSelect,
    tabs,
    testId = TEST_ID
}) => (
    <Tabs className={`${className} ${styles.droneDetailsDrawerTabs}`} testId={testId}>
        {tabs.map(({ key, label }, index) => {
            const isActive = index === activeIndex;
            const activeClass = isActive ? styles.tabActive : '';

            return (
                <Tab
                    className={`${styles.tab} ${activeClass}`}
                    isActive={isActive}
                    key={key}
                    onClick={() => onSelect(index)}
                    text={label}
                />
            );
        })}
    </Tabs>
);

export default DroneDetailsDrawerTabs;
